import React, { useCallback } from "react";
import { useAxiosAuth0 } from "@shared/config/useAxiosAuth0";
import LinkBandwidthChart from "../Shared/Bandwidth/LinkBandwidthChart";
import { fetchExtenderPopPerformanceAPI } from "./requests/request";

interface Props {
  extenderPopId: number;
  /** portAllocationId of the link, from the detail's `links`. */
  linkId: number;
  /** Customer-facing link label, e.g. "Uplink — QRO1 (AXTEL)". */
  title: string;
  tenantId: number;
}

/**
 * Bandwidth Utilization of one Extender PoP link (a backbone uplink or the
 * HA interconnect). The card itself is the shared `LinkBandwidthChart`.
 */
const ExtenderPopLinkBandwidthChart: React.FC<Props> = ({
  extenderPopId,
  linkId,
  title,
  tenantId,
}) => {
  const api = useAxiosAuth0();

  const fetchBandwidth = useCallback(
    async (interval: string, timeRange: string) => {
      const response = await fetchExtenderPopPerformanceAPI(
        api,
        String(extenderPopId),
        String(linkId),
        interval,
        tenantId,
        timeRange
      );
      const utilization = response.data?.data?.bandwidthUtilization;
      return response.data?.success && utilization
        ? {
            inbound: utilization.inbound ?? [],
            outbound: utilization.outbound ?? [],
          }
        : null;
    },
    [api, extenderPopId, linkId, tenantId]
  );

  return <LinkBandwidthChart title={title} fetchBandwidth={fetchBandwidth} />;
};

export default ExtenderPopLinkBandwidthChart;
